import * as z from "zod/v4";

export const bulkMarkUnableToPick = {
  name: "bulkMarkUnableToPick" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({ markedCount: z.number() }),
};
